const config = {
  analytics: {
    trackingId: "G-LPQ8WSRRYT",
  },
  adsense: {
    publisherId: "ca-pub-PLACEHOLDER",
  },
  amazon: {
    associateTag: "consensus0e-20", // Placeholder
  },
  social: {
    twitter: "@ConsensusBB", // Placeholder
  },
  meta: {
    defaultTitle: "Consensus Big Boards - Community Rankings",
    defaultDescription: "Rank your favorites. Debate with the community. Discover the consensus on movies, games, food, and NFL Draft prospects.",
    siteUrl: "https://consensusbigboards.com",
  }
};

// API base: same-origin on the production domain (apex or www), env-configured elsewhere.
export const BACKEND_URL =
  typeof window !== 'undefined' && /(^|\.)consensusbigboards\.com$/.test(window.location.hostname)
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export const NFL_CURRENT_CLASS = "2027";
export const NFL_ARCHIVED_CLASSES = ["2026"];
export const NFL_POSITION_MAP = {
  "Quarterbacks": "QB", "Running Backs": "RB", "Wide Receivers": "WR", "Tight Ends": "TE",
  "Offensive Line": "OL", "Defensive Line": "DL", "Edge Rushers": "EDGE", "Linebackers": "LB",
  "Cornerbacks": "CB", "Safeties": "S",
};
export const isArchivedNflSubcategory = (sub) => NFL_ARCHIVED_CLASSES.includes(sub) || /^\d{4} /.test(sub || '');

export default config;
